import { useQuery } from '@tanstack/react-query';
import { useAxios } from '../../../api/axios';
import { useTranslation } from 'react-i18next';
// import { useParams } from 'react-router-dom';

export const usePropertyDetail = (propertyId: string) => {
  const axios = useAxios();
  const { t } = useTranslation();
  const urlKey = `${t('pub-property-detail-api')}?id=${propertyId}`;
  
  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ['Property-Detail', propertyId],
    queryFn: async () => {
      const res = await axios.get(urlKey);
      return res?.data;
    },
    refetchOnMount: true,
    enabled: !!propertyId,
  });
  return { data: data?.data, isLoading, isFetching, refetch };
};
